import React, { FunctionComponent, useContext, useState } from 'react';
import {
    genClassNames,
    LatLng,
    TKGeocodingOptions,
    TKPeliasGeocoder,
    TKRegionResults,
    TKRegionsData,
    TKRoot,
    TKState,
    TKStateUrl,
    TKUIConfig,
    TKUIMapViewProps,
    TKUISettingLink,
    TKUITripPlanner,
    TKUtil,
    Environment,
    TKDefaultGeocoderNames,
    TripGoApi,
    RoutingQuery,
    TKUserProfile,
    TKUISignInFromSettings,
    TKUIUserAccountSetting,
    TKError,
    TKUISettingSection,
    OptionsContext,
    TKUITheme,
    white
} from 'tripkit-react';
import { overrideClass } from "tripkit-react/dist/jss/StyleHelper";
import SchoolLocation from "tripkit-react/dist/model/location/SchoolLocation";
import { ReactComponent as LogoTestflight } from "../images/test-flight.svg";
import { ReactComponent as LogoGooglePlay } from "../images/google-play.svg";
import classNames from 'classnames';
import { ReactComponent as IconReport } from '../images/ic-usersnap.svg';
import { ReactComponent as LogoFull } from "../images/logo-myway-full.svg";
import Constants from "tripkit-react/dist/util/Constants";
import { feedbackTextFromState } from 'tripkit-react/dist/feedback/TKUIReportBtn';
import { TKUIIconName } from 'tripkit-react/dist/service/TKUIIcon';
import { ReactComponent as IconBikeRackMini } from "../images/ic-bike-rack-mini.svg";
import ModeIdentifier from 'tripkit-react/dist/model/region/ModeIdentifier';
import TransportUtil from 'tripkit-react/dist/trip/TransportUtil';
import LocationUtil from 'tripkit-react/dist/util/LocationUtil';
import TKUIAccountBtn from 'tripkit-react/dist/account/TKUIAccountBtn';
import TKAWSCognitoAccountProvider, { RequestUserTokenInput } from 'tripkit-react/dist/account/TKAWSCognitoAccountProvider';
import MultiSignInForm from './account/MultiSignInForm';
import TKAuthResponse from 'tripkit-react/dist/account/TKAuthResponse';
import NetworkUtil from 'tripkit-react/dist/util/NetworkUtil';
import { ReactComponent as IconLoading } from "tripkit-react/dist/images/ic-spin-bar.svg.js";
import { TKAccountContext } from 'tripkit-react/dist/account/TKAccountContext';
import UIUtil from 'tripkit-react/dist/util/UIUtil';
import { TKI18nContext } from 'tripkit-react/dist/i18n/TKI18nProvider';
import { getEnvironmentConfig } from '../environments';
import OptionsData from 'tripkit-react/dist/data/OptionsData';
import { TripSort } from 'tripkit-react/dist/model/trip/TripSort';
import TGUIDevSettingsView, { getApiKey, getServer, setPredefinedApiKeys, setPredefinedServers } from '../../../../options/TGUIDevSettingsView';
import OptionsProvider from 'tripkit-react/dist/options/OptionsProvider';

interface IProps { }

let test403: boolean;
const urlSearch = new URLSearchParams(window.location.search);
if (urlSearch.get("test403") === "true") {
    test403 = true;
    window.history.replaceState(null, "", window.location.pathname);
}

TKError.debugMode = true;

const NEC_API_KEY = "6a78bd5bbd5d8895cd9a5f306947f5f8";  // Web specific api key

const hostname = window.location.hostname;
const isBeta = hostname.includes("beta.localhost") || hostname.includes("-beta") || hostname === "localhost" || localStorage.getItem("isBeta") === "true";

if (isBeta) {   // TGUIDevSettingsView uses the first entry as the default, so this is to make SATAPP_BETA the default server when isBeta.
    setPredefinedServers({
        'beta': TripGoApi.SATAPP_BETA,
        'production': TripGoApi.SATAPP
    });
    setPredefinedApiKeys({
        'production': NEC_API_KEY
    });
}

const regionsFallback = require("./regionsFallback.json");
TKRegionsData.regionsJsonFallback = regionsFallback;


TransportUtil.remoteIconResourcesBaseUrl = "https://static.skedgo.com/icons/";

// LocationUtil.relevanceStr = (query: string, searchResult: string, options: { preferShorter?: boolean } = {}) => {
//     return relevance(query, searchResult);
// };

/**
 * Start with map on (initViewport) default city (the first one of hardcoded region) until wait for user location.
 * When user location resolves, if it lays inside region bounds, then focus map on it, otherwise do nothing.
 * Use a hardcoded version of regions.json to avoid waiting for them to move the map to the user location or default city.
 */
const defaultRegions: TKRegionResults = TKUtil.deserialize(regionsFallback, TKRegionResults);
const userLocationPromise = (window as any).tKUserLocationPromise ?
    (window as any).tKUserLocationPromise
        .then((userCoords: [number, number]) => LatLng.createLatLng(userCoords[0], userCoords[1]))
        // .then(TKNetworkUtil.delayPromise(4000))
        .then((userLatLng: LatLng) => {
            for (const region of defaultRegions.regions) {
                if (region.contains(userLatLng)) {
                    return userLatLng;
                }
            }
            throw "User location outside bounds."
        })
    : undefined;

const envConfig = getEnvironmentConfig();

const ShowCustomerPortalLink: FunctionComponent<{ setShowSignInForm }> = (props) => {
    const { setShowSignInForm } = props;
    const { t } = useContext(TKI18nContext);
    const [waiting, setWaiting] = useState(false);
    const { logout } = useContext(TKAccountContext);
    const handleCustomerPortalClick = async () => {
        setWaiting(true);
        try {
            if (test403) {
                await NetworkUtil.delayPromise(2000)(null);
                throw new TKError("Test 403 error", 403);
            }
            const { authToken } = await TripGoApi.fetchAPI(TripGoApi.getSatappUrl("/data/user/auth/nec/cptoken"), {
                method: "GET",
                // ...test403 ? {
                //     headers: {
                //         "testValue": "403"
                //     }
                // } : {}
            });
            console.log(authToken);
            window.open(`${envConfig.open_portal}?authToken=${authToken}`, "_blank");
        } catch (error) {
            if (error instanceof TKError) {
                if (error.code === 403) {
                    UIUtil.customConfirmAlert({
                        title: "Your session expired",
                        message: "Please login again to access the customer portal.",
                        buttons: [
                            {
                                label: t("Cancel"),
                                onClick: () => { }
                            },
                            {
                                label: t("Proceed"),
                                onClick: () => {
                                    logout();
                                    setShowSignInForm(true);
                                }
                            }
                        ]
                    });
                } else {
                    window.open(envConfig.open_portal, "_blank");
                }
            }
        } finally {
            setWaiting(false);
            test403 = false;
        }
    };
    return (
        <TKUISettingLink
            text={"Open Customer Portal"}
            onClick={handleCustomerPortalClick}
            rightIcon={waiting ? () => <IconLoading /> : undefined}
        />
    );
}

const buildConfig = ({ apiKey, apiServer, setShowSignInForm, setShowDevSettings }): TKUIConfig => {
    const analyticsConfig = Environment.isProd() ? {
        google: {
            tracker: {
                trackingId: "G-___"
            }
        }
    } : undefined;

    const defaultRegion = defaultRegions.regions[0];
    const defaultCityLatLng = defaultRegion.cities[0];

    const geocodeEarth = new TKPeliasGeocoder({
        server: "https://api.geocode.earth/v1",
        apiKey: "ge-45764c6f71158c5e",
        restrictToBounds: true,
        region: defaultRegion,
        resultsLimit: 5
    });
    const geocodeEarthID = 'geocodeEarth';

    const computeModeSetsBuilder = defaulFunction =>
        (query: RoutingQuery, options: TKUserProfile) => {
            let modeSets = defaulFunction(query, options);
            if (options.transportOptions.isModeEnabled(ModeIdentifier.SCHOOLBUS_ID)) {
                const schoolModes = [
                    ...(query.from?.class === "SchoolLocation" ? (query.from as SchoolLocation).modeIdentifiers : []),
                    ...(query.to?.class === "SchoolLocation" ? (query.to as SchoolLocation).modeIdentifiers : [])
                ];
                modeSets.forEach(modeSet => {
                    if (modeSet.includes(ModeIdentifier.SCHOOLBUS_ID)) {
                        modeSet.splice(modeSet.indexOf(ModeIdentifier.SCHOOLBUS_ID), 1);
                        // if schoolModes is empty, then it's the case where shoolbus setting is enabled, but we don't request them since from and to are not school locations.
                        modeSet.push(...schoolModes);
                    }
                });
                modeSets = modeSets.filter(modeSet => modeSet.length > 0); // Since schoolbus single modeset may have became empty.
                const modeSetsNoDuplicates: string[][] = [];
                modeSets.forEach(modeSet => {
                    if (!modeSetsNoDuplicates.some(otherModeSet => otherModeSet.every(mode => modeSet.includes(mode)) && modeSet.every(mode => otherModeSet.includes(mode)))) {
                        modeSetsNoDuplicates.push(modeSet);
                    }
                });
                modeSets = modeSetsNoDuplicates;
            }
            return modeSets;
        };

    const initViewport = { center: defaultCityLatLng, zoom: 13 };   // Canberra

    function handleSignInClick() {
        setShowSignInForm(true);
    }

    // Get current profile instead creation a new one to avoid resetting the other options, e.g. isDarkMode and trackTripSelections;
    // Sort preference selection is not recorded in the profile, just default sort is, and we have way to change that default through the
    // UI. So it's safe to reset the profile, and we need to do that to change the default sort.
    // TODO: record, in the profile itself, for each property, if the user has already set that property. Then, just apply a default for a prop
    // if it wasn't explicitly set by the user.
    const defaultUserProfile = OptionsData.instance.get();
    defaultUserProfile.defaultTripSort = TripSort.CALORIES;

    return ({
        apiKey: apiKey,
        apiServer,
        theme: ({ isDark }) => ({
            colorPrimary: isDark ? '#a065d9' : '#582C83'
        }),
        // analytics: analyticsConfig,
        initViewport: initViewport,
        computeModeSetsBuilder,
        geocoding: (defaultOptions: TKGeocodingOptions) => {
            const defaultGeocoders = { ...defaultOptions.geocoders };
            delete defaultGeocoders[TKDefaultGeocoderNames.recent];
            defaultGeocoders[TKDefaultGeocoderNames.skedgo].getOptions().resultsLimit = 10;
            return ({
                geocoders: {
                    ...defaultGeocoders,
                    [geocodeEarthID]: geocodeEarth
                },
                maxResults: 100
            });
        },
        defaultUserProfile,
        resetUserProfile: true,
        TKUIMapView: {
            props: (props: TKUIMapViewProps) => {
                const { trip, tripSegment } = props;
                const mapTiles = tripSegment ? tripSegment.mapTiles : trip?.mainSegment?.mapTiles;
                return (mapTiles ?
                    {
                        tileLayerProps: {
                            attribution: mapTiles.sources
                                .map(source => `<a href=${source.provider.website} tabindex='-1'>${source.provider.name}</a>`)
                                .join(" | "),
                            url: mapTiles.urlTemplates[0]
                        }
                    } :
                    {
                        mapboxGlLayerProps: {
                            accessToken: process.env.NODE_ENV === "development" ? "pk.eyJ1IjoibWdvbWV6bHVjZXJvIiwiYSI6ImNqa3N3aTQ0cjAxZ3UzdnRnbWtyZDY4bXMifQ.mLGxFRgw2xvCmNa8DVrtxA" : "pk.eyJ1IjoibWdvbWV6bHVjZXJvIiwiYSI6ImNsdHEzYnA3bjAyMnMycW9lN3FxdWEwczgifQ.4FvIf33XEbrc7nJEY1f5jg",
                            style: props.theme.isLight ?
                                "mapbox://styles/mgomezlucero/ckjliu0460xxh1aqgzzb2bb34" :
                                "mapbox://styles/mgomezlucero/ckbmm6m0w003e1hmy0ksjxflm",
                            attribution: "<a href='http://osm.org/copyright' tabindex='-1'>OpenStreetMap</a>"
                        }
                    }
                );
            }
            // props: (props: TKUIMapViewProps) => ({
            //     renderLayer: () =>
            //         <TKGoogleLayer
            //             googleMapsLoaderConf={{
            //                 KEY: window.location.hostname.includes("localhost") ? "AIzaSyCZckxpqD6Cqez5VNbcmzCIBUSGgUNUyao" : "AIzaSyBPGqg-SOLk3vKht3i3gl4ydLkkbsVPF34",
            //                 // LANGUAGE: locale,
            //                 LIBRARIES: ['places']
            //             }}
            //         />
            // })
        },
        TKUITripPlanner: {
            props: (props) => ({
                renderTopRight: props.landscape ? () =>
                    <div className={classNames(genClassNames.flex, genClassNames.alignCenter)}>
                        <LogoFull id={'myway-logo'} style={{ height: '60px', margin: '10px 10px 0 0' }} /> {isBeta ? <div style={{ margin: '0 10px 0 -10px', fontFamily: 'sans-serif', fontSize: '20px' }}>beta</div> : null}
                        <TKUIAccountBtn onSignInClick={handleSignInClick} />
                    </div>
                    : undefined
            }),
            styles: (theme: TKUITheme) => ({
                renderTopRight: overrideClass({
                    top: 0,
                    ...theme.isDark ? {
                        '& svg#myway-logo path': {
                            fill: white(1)
                        }
                    } : {}
                })
            })
        },
        TKUISidebar: {
            props: (props) => ({
                renderLogo: () => <><LogoFull id='myway-logo-sidebar' style={{ height: '70px' }} /> {isBeta ? <div style={{ margin: '0 10px 0 -30px', fontFamily: 'sans-serif', fontSize: '20px' }}>beta</div> : null}</>,
                appStoreUrl: !isBeta ? envConfig.app_store_url : undefined,
                playStoreUrl: !isBeta ? envConfig.play_store_url : undefined,
                appStoreImageUrl: !isBeta ? Constants.DEPLOY_URL + '/images/apple-store-logo.png' : undefined,
                playStoreImageUrl: !isBeta ? Constants.DEPLOY_URL + '/images/play-store-logo.png' : undefined,
                nativeAppsTitle: isBeta ? "Test beta mobile app:" : undefined,
                renderNativeAppLinks: isBeta ? () => (
                    <React.Fragment>
                        <div
                            // onClick={() => window.open(envConfig.app_store_url, '_blank')}
                            className={classNames(genClassNames.flex, genClassNames.alignCenter)}
                            style={{
                                height: '70px',
                                width: '144px',
                                cursor: 'pointer'
                            }}
                        >
                            <LogoTestflight style={{ height: '100%', marginRight: '15px' }} />
                            iOS app on TestFlight
                        </div>
                        <div
                            // onClick={() => window.open(envConfig.play_store_url, '_blank')}
                            className={classNames(genClassNames.flex, genClassNames.alignCenter)}
                            style={{
                                height: '70px',
                                width: '170px',
                                cursor: 'pointer'
                            }}
                        >
                            <LogoGooglePlay style={{ height: '100%', marginRight: '15px' }} />
                            Android app on Google Play
                        </div>
                    </React.Fragment>
                ) : undefined
            }),
            styles: (theme: TKUITheme) => ({
                header: overrideClass({
                    ...theme.isDark ? {
                        '& svg#myway-logo-sidebar path': {
                            fill: white(1)
                        }
                    } : {}
                })
            })
        },
        TKUIProfileView: {
            props: {
                accountSettings: () =>
                    <TKUIUserAccountSetting
                        phoneNote={<>To update your phone number, please call <a href="tel:1-833-653-6544">1-833-653-6544</a> and request technical support. A live agent will be able to assist you. The ability to reach you regarding your trip plans is of utmost importance and we appreciate your support with this matter.</>}
                        moreSettings={
                            <ShowCustomerPortalLink setShowSignInForm={setShowSignInForm} />
                        }
                    />,
                customSettings: () => {
                    return (
                        <>
                            <TKUISignInFromSettings onSignInClick={handleSignInClick} />
                            {setShowDevSettings &&
                                <TKUISettingSection>
                                    <TKUISettingLink text={"Beta Testing"} onClick={() => setShowDevSettings(true)} />
                                </TKUISettingSection>}
                        </>
                    );
                }


            }
        },
        // TKUIPrivacyOptionsView: {
        //     props: {
        //         privacyPolicyUrl: 'https://xyz/privacy'
        //     }
        // },
        TKUIReportBtn: {
            props: {
                renderIcon: () => <IconReport />,
                onClick: (state: TKState) => {
                    const reportEmail = "support@skedgo.com";
                    const subject = encodeURIComponent(`Report from ${window.location.hostname}`);
                    const body = encodeURIComponent(feedbackTextFromState(state));
                    window.open(`mailto:${reportEmail}?subject=${subject}&body=${body}`);
                }
            },
            styles: {
                main: overrideClass({ height: '26px', padding: '3px' })
            }
        },
        TKUILocationBox: {
            props: {
                menuMaxHeightPx: 400,
                focus: LatLng.createLatLng(-35.3, 149.1),   // The same as TCCS web-app
            }
        },
        TKUIServiceDepartureRow: {
            props: {
                showOperatorName: true
            }
        },
        TKUIIcon: {
            render: (props, defaultRender) => {
                switch (props.iconName) {
                    case TKUIIconName.bicycleAccessibleMini:
                        return <IconBikeRackMini width={12} height={12} />;
                    case TKUIIconName.bicycleAccessibleSmall:
                        return <IconBikeRackMini width={16} height={16} />;
                    default:
                        return defaultRender(props);
                }
            }
        }
    });
}

const LS_TERMS_AND_CONDITIONS_ALREADY_ASKED = "termsAndConditionsAlreadyAsked";
const TripPlannerApp: React.FunctionComponent<IProps> = (props: IProps) => {
    const { userProfile } = useContext(OptionsContext);
    const [showSignInForm, setShowSignInForm] = useState(false);
    const devSettings = isBeta || hostname === "localhost";
    const [showDevSettings, setShowDevSettings] = useState<boolean>(false);
    const devSettingsView = showDevSettings &&
        <TGUIDevSettingsView
            onRequestClose={() => setShowDevSettings(false)}
        />;
    const apiKey = devSettings ? getApiKey(userProfile) : NEC_API_KEY;
    const apiServer = devSettings ? getServer(userProfile) : TripGoApi.SATAPP;
    const config = buildConfig({
        apiKey,
        apiServer,
        setShowSignInForm,
        setShowDevSettings: devSettings ? setShowDevSettings : undefined
    });
    async function handleRequestUserToken({ accessToken, idToken, refreshToken, fetchUserAttributes }: RequestUserTokenInput): Promise<TKAuthResponse> {
        const userAttributes = await fetchUserAttributes();
        let abtCustomerId = userAttributes["custom:AbtCustomerId"];
        const customAccessToken = userAttributes["custom:access_token"];
        // if (process.env.NODE_ENV === 'development') { // For testing
        //     abtCustomerId = undefined;
        // }
        // customAccessToken is only available when the user is signed in with the hosted UI, this guarantees that this flow is only executed when the user is signed in with hosted UI.
        if (customAccessToken && !abtCustomerId) {
            console.log("No AbtCustomerId found in user attributes.");
            console.log(customAccessToken);
            const customUserInfo = await
                // fetch("https://rmau7hffvj3f3rb3kmuxlgpeum0luqfj.lambda-url.us-east-1.on.aws/", {
                //     method: 'get',
                //     headers: new Headers({
                //         'Accept': 'application/json',
                //         'Authorization': `Bearer ${customAccessToken}`,
                //         "x-url-rewrite": "https://actgov--tccsmyway.sandbox.my.site.com/services/oauth2/userinfo"
                //     })
                // }).then(response => response.json());
                TripGoApi.fetchAPI(apiServer + "/data/user/auth/nec/userinfo", {
                    method: 'GET',
                    headers: new Headers({
                        'X-Cognito-AccessToken': customAccessToken!
                    })
                });
            // const customUserInfo = require('../../../../mock/data/myway/skedgoda_mauro_userinfo.json');
            // const customUserInfo = require('../../../../mock/data/myway/skedgoda_userinfo.json');
            console.log(customUserInfo);
            console.log(customUserInfo.custom_attributes.TermsandConditionsAccepted);
            const termsConditionsAccepted = customUserInfo.custom_attributes.TermsandConditionsAccepted.toLowerCase() === 'true';
            if (!termsConditionsAccepted) {
                if (localStorage.getItem(LS_TERMS_AND_CONDITIONS_ALREADY_ASKED) === "true") {   // If already asked, then abort login (and clear the flag for a future signin).
                    localStorage.removeItem(LS_TERMS_AND_CONDITIONS_ALREADY_ASKED);
                    throw new Error("Terms and conditions not accepted.");  // This is handled in TKAWSCognitoAccountProvider, which will log out the user.
                }
                localStorage.setItem(LS_TERMS_AND_CONDITIONS_ALREADY_ASKED, "true");
                window.open(`${envConfig.tNCs_page_URL}?returnURL=mywayweb`, "_self");
                return new Promise(() => { });  // Return to avoid the code below to execute in the time it takes to redirect to the terms and conditions page. Return a promise that will never resolve since caller expects a user token.
            } else {
                localStorage.removeItem(LS_TERMS_AND_CONDITIONS_ALREADY_ASKED);
            }
            const userId = customUserInfo.user_id;
            const newABTResponse = await TripGoApi.fetchAPI(apiServer + "/data/user/auth/nec/customer", {
                method: 'POST',
                headers: new Headers({
                    'X-Cognito-IDToken': idToken!
                }),
                body: JSON.stringify({ "userName": userId })
            });
            abtCustomerId = newABTResponse.userId;
        }
        return TripGoApi.fetchAPI(TripGoApi.getSatappUrl("/data/user/auth/cognito/" + accessToken), {
            method: "POST",
            headers: {
                "X-Cognito-RefreshToken": refreshToken!,
                "X-Cognito-IDToken": idToken!,
                "X-AbtCustomerId": abtCustomerId ?? '12345'!    // TODO: remove once the isse of this not coming for (some) ABT users is fixed.
            }
        }).then(NetworkUtil.deserializer(TKAuthResponse));
    }
    return (
        <TKAWSCognitoAccountProvider
            amplifyConfig={envConfig.amplifyConfig}
            requestUserToken={handleRequestUserToken}
        >
            <TKRoot config={config}>
                <TKUITripPlanner userLocationPromise={userLocationPromise} />
                {showSignInForm && <MultiSignInForm onRequestClose={() => setShowSignInForm(false)} />}
                <TKStateUrl useHash={true} />
                {devSettingsView}
            </TKRoot>
        </TKAWSCognitoAccountProvider >
    );
};

export default () => {
    return (
        <OptionsProvider>
            <TripPlannerApp />
        </OptionsProvider>
    );
};

/**
 * @param query the search query, typed by the user.
 * @param searchResult the text against which the query is matched.
 * @returns a number between 0 and 1, indicating the relevance of the searchResult to the query.
 */
function relevance(query: string, searchResult: string): number {
    // Lowercase and trim both query and searchResult
    query = query.toLowerCase().trim();
    searchResult = searchResult.toLowerCase().trim();

    // Max relevance if the search result is exactly the query
    if (searchResult === query) {
        return 1;
    }

    // High relevance if the search result starts with the query
    if (searchResult.startsWith(query)) {
        return .85;
    }

    // Otherwise, split query and searchResult into words, and compute relevance based on the words.
    // Max possible relevance will be .8.
    const queryWords = query.split(" ");
    const searchResultWords = searchResult.split(" ");
    let relevance = 0;
    for (const queryWord of queryWords) {       // For each query word
        if (searchResultWords.includes(queryWord)) {    // - if it is one of the search result words, will contribute .8 / queryWords.length to the relevance.
            relevance += .8 / queryWords.length;
            continue;
        }
        if (searchResultWords.some(w => w.startsWith(queryWord))) { // - if it is a prefix of one of the search result words, will contribute .7 / queryWords.length to the relevance.
            relevance += .7 / queryWords.length;
            continue;
        }
        if (searchResultWords.some(w => w.includes(queryWord))) {  // - if it is included in one of the search result words, will contribute .6 / queryWords.length to the relevance.
            relevance += .6 / queryWords.length;
            continue;
        }
        let minDistance = Number.MAX_VALUE;                        // - otherwise, will contribute .5 / (queryWords.length + minDistance) to the relevance,        
        for (const searchResultWord of searchResultWords) {        //   where minDistance is the minimum Levenshtein distance between the query word and any of the search result words.
            minDistance = Math.min(minDistance,                    //   The higher the distance, the lower the relevance.
                LocationUtil.computeLevenshteinDistance(queryWord, searchResultWord));
        }
        relevance += .5 / (queryWords.length + minDistance);
    }
    return relevance;
}